import React, { Component } from "react"

import LoadingSpinner from "../LoadingSpinner"
import WarehouseSearch from "../warehouses/WarehouseSearch"
import VendorSearch from "../vendors/VendorSearch"
import { fireAxios, toFileDate, dateObjToInputDate, inputDateToDateObj, download } from "../helpers"

type props = {}

type warehouse =
  | {
      id: number
      name: string
    }
  | undefined

type vendor =
  | {
      id: number
      name: string
    }
  | undefined

type state = {
  loading: boolean
  warehouse: warehouse
  toWarehouseSearch: boolean
  vendor: vendor
  toVendorSearch: boolean
  beginDate?: Date
  endDate?: Date
  [index: string]: any
}

const title = "Open Purchase Orders Report"

class OpenPOs extends Component<props & appProps, state> {
  constructor(props: props) {
    super(props)

    this.state = {
      loading: false,
      warehouse: undefined,
      toWarehouseSearch: false,
      vendor: undefined,
      toVendorSearch: false,
    }

    if (this.props.setAppTitle) {
      this.props.setAppTitle(title)
    }
  }

  warehouseResult = (result: warehouse) => {
    this.setState({
      warehouse: result,
      toWarehouseSearch: false,
    })
  }

  toWarehouseSearch = () => {
    this.setState({
      toWarehouseSearch: true,
    })
  }

  vendorResult = (result: vendor) => {
    this.setState({
      vendor: result,
      toVendorSearch: false,
    })
  }

  toVendorSearch = () => {
    this.setState({
      toVendorSearch: true,
    })
  }

  backFromSearch = () => {
    this.setState({
      toWarehouseSearch: false,
      toVendorSearch: false,
    })
  }

  updateDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      [e.target.name]: inputDateToDateObj(e.target.value),
    })
  }

  clearDate = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      [e.currentTarget.name]: undefined,
    })
  }

  submitRequest = () => {
    this.setState({ loading: true }, () => {
      fireAxios(
        {
          method: "post",
          url: "reports/openpos/",
          data: {
            begin_date: this.state.beginDate,
            end_date: this.state.endDate,
            warehouse_id: this.state.warehouse ? this.state.warehouse.id : undefined,
            vendor_id: this.state.vendor ? this.state.vendor.id : undefined,
          },
        },
        (response) => {
          this.setState({ loading: false }, () => {
            download(
              "Excel",
              response.data,
              "OpenPOs" +
                "_" +
                (this.state.warehouse ? this.state.warehouse.name : "") +
                (this.state.beginDate ? "_" + toFileDate(this.state.beginDate || "") : "") +
                (this.state.endDate ? "_" + toFileDate(this.state.endDate || "") : "")
            )
          })
        }
      )
    })
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />
    }

    if (this.state.toWarehouseSearch) {
      return (
        <div>
          <button onClick={this.backFromSearch}>Back to {title}</button>
          <br />
          <br />
          <WarehouseSearch returnResult={this.warehouseResult} />
        </div>
      )
    }

    if (this.state.toVendorSearch) {
      return (
        <div>
          <button onClick={this.backFromSearch}>Back to {title}</button>
          <br />
          <br />
          <VendorSearch returnResult={this.vendorResult} />
        </div>
      )
    }

    return (
      <div>
        <label htmlFor="beginDate">Begin Date (optional): </label>
        <input
          type="date"
          name="beginDate"
          onChange={this.updateDate}
          value={this.state.beginDate ? dateObjToInputDate(this.state.beginDate) || "" : ""}
        />
        <button name="beginDate" onClick={this.clearDate}>
          Clear
        </button>

        <br />
        <br />

        <label htmlFor="endDate">End Date (optional): </label>
        <input type="date" name="endDate" onChange={this.updateDate} value={this.state.endDate ? dateObjToInputDate(this.state.endDate) || "" : ""} />
        <button name="endDate" onClick={this.clearDate}>
          Clear
        </button>

        <br />
        <br />

        <label htmlFor="warehouse">
          {this.state.warehouse ? "Warehouse: " : "Select Warehouse (optional): "}
          <b>{this.state.warehouse ? this.state.warehouse.name + " " : " "}</b>
        </label>
        <button name="warehouse" onClick={() => this.toWarehouseSearch()}>
          {this.state.warehouse ? "Edit" : "Add"}
        </button>
        {this.state.warehouse ? <button onClick={() => this.warehouseResult(undefined)}>Clear</button> : null}

        <br />
        <br />

        <label htmlFor="vendor">
          {this.state.vendor ? "Vendor: " : "Select Vendor (optional): "}
          <b>{this.state.vendor ? this.state.vendor.name + " " : " "}</b>
        </label>
        <button name="vendor" onClick={() => this.toVendorSearch()}>
          {this.state.vendor ? "Edit" : "Add"}
        </button>
        {this.state.vendor ? <button onClick={() => this.vendorResult(undefined)}>Clear</button> : null}

        <br />
        <br />

        <button onClick={this.submitRequest}>Generate</button>
      </div>
    )
  }
}
export default OpenPOs
